import { useSelector } from "react-redux";
import { LoadingOutlined, FieldTimeOutlined } from "@ant-design/icons";
import { useLastUpdatedTime } from "hooks/useLastUpdatedTime";


const LastUpdatedStatus = ({showTime='time', lastUpdatedTime}) => {
    //Prop showTime can be one of, 
    //  'time' -- Shows last updated time
    //  'time-ago' -- Show time difference in between current time and last updated time
    //  'time-left' -- Show time left (coutdown) before next update
    
    const pageLoader = useSelector((state) => state.loader)?.pageLoader;
    const timeDiff = useLastUpdatedTime(showTime, lastUpdatedTime, 10)
    var timeText = '';

    switch(showTime){
        case 'time': timeText = `Updated at: ${timeDiff}`; break;
        case 'time-ago': timeText = `Updated ${timeDiff} ago`; break;
        case 'time-left': timeText = `Updating in ${timeDiff}`; break;
        default: timeText = `Updated at: ${timeDiff}`; break;
    }
    return(
        (pageLoader === 'refresh' || (pageLoader === 'live' && parseInt(timeDiff) < 1)) ? (
            <>
                <LoadingOutlined className="mr05" />
                <div className="page-status-text">Updating</div>
            </>
        ): pageLoader === 'live' ? (
            <>
                <FieldTimeOutlined className="mr05" />
                <div className="page-status-text">{timeText}</div>
            </>
        ): null
    )
}

export default LastUpdatedStatus;

